<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="12">
                <CRow>
                  <CCol sm="3">
                    <CInput
                      label="Voucher Code"
                      invalid-feedback="Voucher Code should be filled"
                      required
                      :readonly="true"
                      v-model="$v.voucherForm.voucher_code.$model"
                      :is-valid="!$v.voucherForm.voucher_code.$invalid"
                    />
                  </CCol>
                  <CCol sm="3">
                    <div class="form-group">
                      <label for="voucher_group">Voucher Group</label>
                      <model-select
                        class="form-control"
                        id="voucher_group"
                        :options="voucherGroupList"
                        v-model="$v.voucherForm.voucher_group.$model"
                        :isError="$v.voucherForm.voucher_group.$invalid"
                        :isDisabled="true"
                        :isRequired="true"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.voucherForm.voucher_group.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Voucher Group should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="3">
                    <CInput
                      label="Voucher Name"
                      invalid-feedback="Voucher name should be filled"
                      required
                      v-model="$v.voucherForm.name.$model"
                      :is-valid="!$v.voucherForm.name.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                  <CCol sm="3">
                    <CInput
                      label="Abbreviation"
                      invalid-feedback="Abbreviation should be filled"
                      required
                      v-model="$v.voucherForm.abbreviation.$model"
                      :is-valid="!$v.voucherForm.abbreviation.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="3">
                    <div class="form-group">
                      <label for="voucher_type">Tipe Voucher</label>
                      <model-select
                        class="form-control"
                        id="voucher_type"
                        :options="voucherTypeList"
                        v-model="$v.voucherForm.voucher_type.$model"
                        :isError="$v.voucherForm.voucher_type.$invalid"
                        :isRequired="true"
                        @input="filterVoucherType"
                        placeholder="-- Harap pilih salah satu --"
                        :isDisabled="isReadonly"
                      ></model-select>
                      <div
                        v-if="$v.voucherForm.voucher_type.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Voucher Type should be filled.
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3" v-if="voucherForm.voucher_type == 1">
                    <CInput
                      type="number"
                      label="Price Cut (dalam Rupiah)"
                      invalid-feedback="Price Cut Should Be Filled"
                      required
                      v-model="$v.voucherForm.price.$model"
                      :is-valid="!$v.voucherForm.price.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                  <CCol sm="3" v-if="voucherForm.voucher_type == 2">
                    <CInput
                      type="number"
                      label="Percentage Cut (dalam %)"
                      invalid-feedback="Percentage Cut Should Be Filled"
                      required
                      v-model="$v.voucherForm.percentage.$model"
                      :is-valid="!$v.voucherForm.percentage.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                  <CCol sm="3">
                    <CInput
                      type="number"
                      label="Maximal Price"
                      invalid-feedback="Maximal Price Should Be Filled"
                      v-model="$v.voucherForm.max_price.$model"
                      :is-valid="!$v.voucherForm.max_price.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="3">
                    <div class="form-group">
                      <label for="start_date">Tanggal mulai Berlaku</label>
                      <vc-date-picker
                        id="start_date"
                        :input-props="{
                          class: !$v.voucherForm.start_date.$invalid
                            ? 'form-control is-valid'
                            : 'form-control is-invalid',
                          placeholder: 'Tanggal Mulai Berlaku',
                        }"
                        :popover="{ placement: 'bottom-start' }"
                        :state="!$v.voucherForm.start_date.$invalid"
                        v-model="$v.voucherForm.start_date.$model"
                        :is-required="true"
                        :style="isReadonly ? 'pointerEvents:none' : ''"
                      ></vc-date-picker>
                      <div
                        v-if="$v.voucherForm.start_date.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Date should be filled.
                      </div>
                    </div>
                  </CCol>

                  <CCol sm="3">
                    <div class="form-group">
                      <label for="end_date">Tanggal Akhir Berlaku</label>
                      <vc-date-picker
                        id="end_date"
                        :input-props="{
                          class: !$v.voucherForm.end_date.$invalid
                            ? 'form-control is-valid'
                            : 'form-control is-invalid',
                          placeholder: 'Tanggal Akhir Berlaku',
                        }"
                        :popover="{ placement: 'bottom-start' }"
                        :state="!$v.voucherForm.end_date.$invalid"
                        v-model="$v.voucherForm.end_date.$model"
                        :is-required="true"
                        disabled="isReadonly"
                        :style="isReadonly ? 'pointerEvents:none' : ''"
                      ></vc-date-picker>
                      <div
                        v-if="$v.voucherForm.end_date.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Date should be filled.
                      </div>
                    </div>
                  </CCol>

                  <CCol sm="3">
                    <div class="form-group">
                      <label for="voucher_status">Status Voucher</label>
                      <model-select
                        class="form-control"
                        id="voucher_status"
                        :options="voucherStatusList"
                        v-model="$v.voucherForm.status.$model"
                        :isError="$v.voucherForm.status.$invalid"
                        :isRequired="true"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.voucherForm.status.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Voucher Status should be filled.
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <CInput
                      type="number"
                      label="Minimum Transaction"
                      invalid-feedback="Minimum Transaction Should Be Filled"
                      v-model="$v.voucherForm.min_transaction.$model"
                      :is-valid="!$v.voucherForm.min_transaction.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <div class="form-group">
                      <label for="payment_method">Payment Method</label>
                      <multi-select
                        :options="paymentList"
                        :selected-options="paymentItem"
                        @select="onSelect"
                        v-model="$v.voucherForm.payment.$model"
                        :isError="$v.voucherForm.payment.$invalid"
                        :disabled="isReadonly"
                        placeholder="-- Harap pilih salah satu --"
                      ></multi-select>
                      <div
                        v-if="$v.voucherForm.payment.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Payment method should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <label for="desription">Description</label>
                    <quill-editor
                      style="height: 150px; margin-bottom: 70px"
                      :content="content.description"
                      :options="editorOption"
                      v-model="$v.voucherForm.description.$model"
                      :disabled="isReadonly"
                      @change="onEditorChange($event, 'description')"
                    >
                    </quill-editor>
                    <div
                      v-if="$v.voucherForm.description.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Description harus di isi.
                    </div>
                  </CCol>
                  <CCol sm="6">
                    <label for="tnc">Syarat Dan Ketentuan</label>
                    <quill-editor
                      style="height: 150px; margin-bottom: 70px"
                      :content="content.tnc"
                      :options="editorOption"
                      v-model="$v.voucherForm.tnc.$model"
                      :disabled="isReadonly"
                      @change="onEditorChange($event, 'tnc')"
                    >
                    </quill-editor>
                    <div
                      v-if="$v.voucherForm.tnc.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Syarat dan ketentuan harus di isi.
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.voucherForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Blast Voucher</template>
            <br />
            <VoucherBlast
              :voucher-status="statusVoucher"
              :user-group-list="userGroupList"
              :user-comunity-list="userComunityList"
              :voucher.sync="voucherForm"
            ></VoucherBlast>
          </CTab>

          <CTab>
            <template slot="title">Voucher Images</template>
            <br />
            <VoucherImages
              :voucher.sync="voucherForm"
              :voucher-status="statusVoucher"
            ></VoucherImages>
          </CTab>

          <template v-if="voucherForm.voucher_group === '1'">
            <CTab>
              <template slot="title">Voucher Agent</template>
              <br />
              <VoucherAgent
                :agent-list="agentList"
                :voucher-agent="voucherAgentList"
                :voucher-status="statusVoucher"
                :voucher.sync="voucherForm"
              ></VoucherAgent>
            </CTab>
          </template>

          <template v-if="voucherForm.voucher_group === '1'">
            <CTab>
              <template slot="title">Voucher Product</template>
              <br />
              <VoucherProduct
                :agent-list="agentList"
                :voucher="voucherForm"
                :product-list="productList"
                :voucher-product="voucherProductList"
                :voucher-status="statusVoucher"
              ></VoucherProduct>
            </CTab>
          </template>

          <template v-if="voucherForm.voucher_group === '2'">
            <CTab>
              <template slot="title">Voucher Product QR</template>
              <br />
              <VoucherProductQr
                :agent-list="agentList"
                :voucher="voucherForm"
                :product-list="productList"
                :voucher-product-qr="voucherProductQrList"
                :voucher-status="statusVoucher"
              ></VoucherProductQr>
            </CTab>
          </template>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";
import custom_validation from "@/templates/_customValidation.js";
import VoucherProduct from "./tabs/VoucherProduct";
import VoucherProductQr from "./tabs/VoucherProductQr";
import VoucherImages from "./tabs/VoucherImages";
import VoucherAgent from "./tabs/VoucherAgent";
import VoucherBlast from "./tabs/VoucherBlast";

import { MultiSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import _ from "lodash";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "VoucherDetail",
  components: {
    GlobalTable,
    Loading,
    VoucherProduct,
    VoucherProductQr,
    VoucherImages,
    VoucherAgent,
    VoucherBlast,
    quillEditor,
    MultiSelect,
  },
  data() {
    return {
      title: "Voucher Detail",
      voucherForm: tableInterfaces.voucher,
      voucherProductList: [],
      voucherProductQrList: [],
      voucherAgentList: [],
      productList: [],
      agentList: [],
      userGroupList: [],
      userComunityList: [],
      isLoading: false,
      activeTab: 0,
      voucherTypeList: [
        { value: "1", text: "Diskon Harga" },
        { value: "2", text: "Diskon Persen" },
      ],
      voucherStatusList: [],
      voucherGroupList: [],
      statusVoucher: null,
      content: {
        description: "",
        tnc: "",
      },
      editorOption: {}, // data quill
      paymentList: [],
      paymentItem: [],
    };
  },
  validations() {
    if (this.voucherForm.voucher_type == 1) {
      return custom_validation.detailVoucherFormCustom.price_cut;
    } else {
      return custom_validation.detailVoucherFormCustom.percentage_cut;
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return this.statusVoucher !== "3" ? true : false;
    },
  },
  methods: {
    init: function (id) {
      this.getDropdown();
      this.getDetailVoucher(id);
      this.getPaymentList();
    },
    getDetailVoucher: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/voucher/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response.data.data)

            this.voucherForm = response.data.data;

            if (response.data.payment_allowed !== null) {
              this.paymentItem = response.data.payment_allowed;
              this.voucherForm.payment = response.data.payment_allowed;
            } else {
              this.paymentItem = [];
              this.voucherForm.payment = [];
            }

            this.voucherProductList = response.data.voucher_product;
            this.voucherProductQrList = response.data.voucher_product_qr;
            this.voucherAgentList = response.data.voucher_agent;

            this.statusVoucher = response.data.data.status;

            // //if data type is date, should use this
            // //this.voucherForm.status = response.data.data.status;
            this.voucherForm.start_date = new Date(this.voucherForm.start_date);
            if (response.data.data.end_date == null) {
              this.voucherForm.end_date = null;
            } else {
              this.voucherForm.end_date = new Date(this.voucherForm.end_date);
            }

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });

      // this.getVoucherType();
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/voucher_detail").then((response) => {
        this.voucherStatusList = response.data.voucher_status;
        this.voucherGroupList = response.data.voucher_group;
        this.agentList = response.data.agent;
        this.userGroupList = response.data.user_group;
        this.userComunityList = response.data.user_comunity;
      });
    },
    getPaymentList: function () {
      this.axios
        .get("console/dropdown/payment_method_list")
        .then((response) => {
          this.paymentList = response.data.data;
        });
    },
    onSelect(paymentItem, lastSelectItem) {
      this.paymentItem = paymentItem;
      this.voucherForm.payment = paymentItem;
    },
    onEditorChange({ quill, html, text }, param) {
      this.content[param] = html;
      this.voucherForm[param] = html;
    },
    filterVoucherType: function (event) {
      if (this.voucherForm.voucher_type == 1) {
        if (
          confirm(
            "Apakah anda yakin ingin merubah tipe voucher ini ? (DATA POTONGAN PERSEN AKAN HILANG)"
          )
        ) {
          this.voucherForm.percentage = null;
        }
      } else {
        if (
          confirm(
            "Apakah anda yakin ingin merubah tipe voucher ini ? (DATA POTONGAN HARGA AKAN HILANG)"
          )
        ) {
          this.voucherForm.price = null;
        }
      }
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.voucher) {
        tableInterfaces.voucher[i] = null;
      }
      this.voucherForm = tableInterfaces.voucher;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah voucher ini ?")) {
        if (
          (this.voucherForm.voucher_type == 1 &&
            this.voucherForm.price >= 0 &&
            this.voucherForm.price <= 1000000000) ||
          (this.voucherForm.voucher_type == 2 &&
            this.voucherForm.percentage >= 0 &&
            this.voucherForm.percentage <= 100)
        ) {
          this.isLoading = true;
          this.axios
            .put("console/voucher/update", this.voucherForm)
            .then((response) => {
              this.showInfoNotification({
                title: "Ubah voucher detail",
                message: response.data.message,
              });
            })
            .catch((error) => {
              this.expired(error, "Ubah voucher detail error");
            })
            .finally(() => {
              this.isLoading = false;
              let route = this.$route.path.split("/");
              this.init(route[4]);
            });
        } else {
          alert(
            "Percentage dan Price harus Angka\n\nPRICE CUT MAX 1.000.000.000\nPERCENTAGE CUT MAX 100"
          );
        }
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
    //console.log(this.voucherForm);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
